import keymirror from 'keymirror';

export const ACTIONS = keymirror({
    AUTH_INPUT_CHANGED: null,
    AUTH_LOGIN_USER_SUCCESS: null,
    AUTH_LOGIN_USER_FAIL: null,
    AUTH_LOGIN_USER: null,
    AUTH_SIGNUP_USER_SUCCESS: null,
    AUTH_SIGNUP_USER_FAIL: null,
    AUTH_SIGNUP_USER: null,
    AUTH_IS_USER_AUTHENTICATED: null,
    AUTH_LOGOUT_USER: null,
    AUTH_EMAIL_FORMAT_ERROR: null,
    AUTH_EMPTY_PASSWORD_ERROR: null,
    AUTH_PASSWORD_UNMATCHED: null,
    AUTH_REQUEST_PASSWORD_CODE: null,
    AUTH_VALIDATE_PASSWORD_CODE: null,
    AUTH_VALIDATE_PASSWORD: null,
    AUTH_SET_LOADING: null,
    AUTH_SET_ERROR: null,
    AUTH_PASSWORD_CHANGED: null,
    AUTH_LOGIN_ERROR: null,
    AUTH_RESET_REDUCER: null,
    AUTH_ERROR: null
});



// WEBPACK FOOTER //
// ./src/containers/Auth/auth.actionTypes.js